import * as React from 'react';
import QuickBookIntegration from '../../images/QuickBoooks-and-Xerox-Integration-Feature.png'
import PostalMail from '../../images/Recipients-Postal-Mailing-Feature.png'
import StaffManagement from '../../images/Staff-Managment.png'
import TopSecurity from '../../images/Top-Security.png'

import {
    CardWrap,
    Column1,
    Column2, FeatureRow, FeaturesWrapper,
    InfoContainer,
    Subtitle,
    TextWrapper,
    TopLine
} from '../InfoSection/InfoElements';
import FeaturesTabs from "../../tabs/FeaturesTabs";


const FeaturesSection= (features) => {
    return (
        <>


            <InfoContainer lightBg={features.lightBg} id={features.id}>
                <FeaturesWrapper>
                    <FeaturesTabs {...features}></FeaturesTabs>
                </FeaturesWrapper>
            </InfoContainer>

        </>
    )
}


export default FeaturesSection;




